import React from "react"
import list_DARK from "../../assets/list_DARK.png"
import list_LIGHT from "../../assets/list_LIGHT.png"
import { type Props } from "./_types"
const IconListCustom: React.FC<Props> = ({ size = 15, color = "#fff" }): React.ReactElement => {
  return <img src={color === "DARK" ? list_DARK : list_LIGHT} alt="edit icon" />
}

export default IconListCustom
